export interface IFilterOptions {
    countryISO31661Alpha2Code: string;
}
